import { createStore } from 'vuex'
import services from './services.json'
import estudios from './estudios.json'
import prensa from './prensa.json'
import casos from './casos.json'
import heroSlides from './hero-slides.json'

export const SERVICE_CATEGORY_ID = Object.freeze({
  estrategiaValorCorporativo: '01',
  gestionGruposInteres: '02',
  dataAnalytics: '03',
  tecnologiaDesarrolloSoftware: '04',
})

export default createStore({
  state: {
    services: services,
    estudios: estudios,
    prensa: prensa,
    casos: casos,
    heroSlides: heroSlides,
  },
  getters: {
    highlightedEstudios(state) {
      return (state.estudios ?? []).filter((estudio) => estudio?.highlight === true)
    },
    highlightedPrensa(state) {
      return (state.prensa ?? []).filter((prensa) => prensa?.highlight === true)
    },
    highlightedCasos(state) {
      return (state.casos ?? []).filter((caso) => caso?.highlight === true)
    },
    casoByLink: (state) => (linkOrSlug) => {
      if (linkOrSlug == null || String(linkOrSlug).trim() === '') return null
      const normalized = String(linkOrSlug).trim().replace(/^\//, '')
      return (state.casos ?? []).find((caso) => {
        const casoSlug = String(caso?.link ?? '').trim().replace(/^\//, '')
        return casoSlug === normalized
      }) ?? null
    },
    homePageServices(state) {
      const categories = state.services ?? []
      const out = []
      for (const cat of categories) {
        const urlCategory = cat?.url_category ?? ''
        for (const svc of cat?.services ?? []) {
          if (svc?.is_in_home_page === true) {
            out.push({ ...svc, url_category: urlCategory })
          }
        }
      }
      return out
    },
    servicesByCategory: (state) => (categoryId) => {
      if (categoryId == null || String(categoryId).trim() === '') return []

      const id = String(categoryId).trim()
      const group = (state.services ?? []).find((c) => String(c?.id ?? '').trim() === id)

      return group?.services ?? []
    },
    prensaByLink: (state) => (linkOrSlug) => {
      if (linkOrSlug == null || String(linkOrSlug).trim() === '') return null
      const normalized = String(linkOrSlug).trim().replace(/^\//, '')
      return (state.prensa ?? []).find((item) => {
        const prensaSlug = String(item?.link ?? '').trim().replace(/^\//, '')
        return prensaSlug === normalized
      }) ?? null
    },
    /** Primeras N palabras de un texto (por defecto 15), con "…" si se recorta */
    prensaDescriptionExcerpt: () => (text, wordCount = 15) => {
      const raw = String(text ?? '').trim()
      if (!raw) return ''
      const words = raw.split(/\s+/).filter(Boolean)
      if (words.length <= wordCount) return raw
      return `${words.slice(0, wordCount).join(' ')}…`
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
